import React, { useState } from "react";

import LuxonUtils from "@date-io/luxon";
import { Box, MenuItem, Select } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DateTime } from "luxon";

import makeStyles from "hooks/makeStyles";
import useBusiness from "hooks/useBusiness";
import { DeliveryOrPickupAtControllerProps } from "hooks/useDeliveryOrPickupAtController";
import useTranslation from "hooks/useTranslation";
import CalendarIcon from "icons/CalendarIcon";
import ClockFive from "icons/ClockFive";

const useStyles = makeStyles(theme => ({
	pickupDateIcon: {
		height: theme.spacing(2),
		width: theme.spacing(2.5),
		marginRight: -theme.spacing(3),
		verticalAlign: "middle"
	},
	pickupTimeIcon: {
		height: theme.spacing(2),
		width: theme.spacing(2.5),
		marginRight: theme.spacing(1),
		verticalAlign: "middle"
	},
	selectorItem: {
		marginBottom: theme.spacing(2.5),
		textTransform: "uppercase"
	},
	closeButton: {
		padding: 0,
		textAlign: "right",
		alignSelf: "flex-end",
		margin: "16px"
	},
	closeIcon: {
		width: 21,
		height: 21,
		color: "#fff",
		fill: "#4F4F4F"
	}
}));

const OrderTimeSelectorRendererMobile = ({ items, selection, setValue }: DeliveryOrPickupAtControllerProps) => {
	const { business } = useBusiness();
	const [date, setDate] = useState(selection.date);
	const { t } = useTranslation();
	const classes = useStyles();

	const minDate = items[0].dt;
	const maxDate = items[items.length - 1].dt;

	const selectedItem = items.find(x => x.value === date) || selection.item;

	return (
		<MuiPickersUtilsProvider utils={LuxonUtils}>
			<Box>
				<KeyboardDatePicker
					className={classes.selectorItem}
					autoOk
					inputVariant="outlined"
					variant="inline"
					openTo="date"
					format="MMMM d"
					fullWidth
					minDate={minDate}
					maxDate={maxDate}
					onChange={v => setDate((v as DateTime).setZone(business.timeZone).toISODate())}
					value={DateTime.fromISO(date, { zone: business.timeZone })}
					InputAdornmentProps={{ position: "end" }}
					keyboardIcon={<CalendarIcon fill="#4F4F4F" className={classes.pickupDateIcon} />}
				/>
				<Select
					className={classes.selectorItem}
					value={selection.value || "-"}
					placeholder={t("selectDeliveryTime")}
					variant="outlined"
					onChange={event => setValue(event.target.value === "-" ? "" : (event.target.value as string))}
					fullWidth={true}
					IconComponent={() => <ClockFive fill="#4F4F4F" className={classes.pickupTimeIcon} />}
				>
					{selectedItem.times.map(x => (
						<MenuItem key={x.value} value={x.value || "-"}>
							{x.text || t("asap")}
						</MenuItem>
					))}
				</Select>
			</Box>
		</MuiPickersUtilsProvider>
	);
};

export default OrderTimeSelectorRendererMobile;
